import "./privacypolicy.css";

export default function PrivacyPolicy () {
  return (<>
    <section className="policy">
      <h1>Privacy Policy</h1>
      {/* Introduction */}
      <p>
        <span>Silver K Gallery </span>
        is committed to providing quality services to you and this policy outlines our ongoing obligations to you in respect of how we manage your <a href="#personalinfo">Personal Information</a>.
      </p>
      <p>
        We have adopted the Australian Privacy Principles (APPs) contained in the Privacy Act 1988 (Cth) (the Privacy Act). The NPPS govern the way in which we collect, use, disclose, store, secure and dispose of your <a href="#personalinfo">Personal Information</a>.
      </p>
      <p id="personalinfo">
        A copy of the Australia Privacy Principles may be obtained from the website of The Office of the Australia Information Commissioner at <a href="https://www.oaic.gov.au/">https://www.oaic.gov.au/</a>.
      </p>

      <h2>What is Personal Information and why do we collect it?</h2>
      
      <p>
        Personal Information is information or an opinion that identifies an individual. The only form of Personal Information we collect are <span>email addresses</span>.
      </p>

      <p>
        This Personal Information is obtained in many way including <span>submitting a query or signing up to Silver K's weekly newsletter</span>.
      </p>

      <p>
        We collect your Personal Information for the primary purpose of providing our services to you, providing information to our clients and marketing. You may unsubscribe from our mailing/marketing lists at any time by contacting us in writing.
      </p>

      <h2>Disclosure</h2>
      <p>
        We <span>do not</span> sell, share, or rent your email address to any third parties.
      </p>

      <h2>Cookies</h2>

      <p>
        Our website <span>does not</span> use cookies.
      </p>

      <h2>Sensitive Information</h2>
      
      <p><span>No</span> sensitive information is collected.</p>

      <h2>Third Parties</h2>

      <p>Where resonable and practiceable to do so, we will collect your <a href="#personalinfo">Personal Information</a> only from you.<span> No information will be accessed from third parties.</span></p>

      <h2>Disclosure of Personal Information</h2>

      <p>Your <a href="#personalinfo">Personal Information</a> may be disclosed in only one circumstance, where in which it is<span> required or authorised by law.</span></p>

      <h2>Security of Personal Information</h2>

      <p>Your <a href="#personalinfo">Personal Information</a> is stored in a manner that reasonably protects it from misuse and loss and from unauthorised access, modification or disclosure.</p>

      <p>When your <a href="#personalinfo">Personal Information</a> is no longer needed for the purpose for which it was obtained, we will take reasonable steps to destory or permanently de-identify your <a href="#personalinfo">Personal Information</a>. However, most of the <a href="#personalinfo">Personal Information</a> is or will be stored in client files which will be <span> kept by us </span> for a <span> minimum of 5 years.</span></p>

      <h2>Access to your Personal Information</h2>

      <p>You may access the <a href="#personalinfo">Personal Information</a> we hold about you and to update and/or correct it, subject to certain exceptions. If you wish to access your <a href="#personalinfo">Personal Information</a>, please contact us in writing.</p>

      <p><span>Silver K gallery</span> will not charge any fee for your access request by may charge an administrative fee for providing a copy of your <a href="#personalinfo">Personal Information</a>.</p>

      <p>In order to protect your <a href="#personalinfo">Personal Information</a>, we may require identification from you before releasing the requested information.</p>

      <h2>Maintaing the Quality of your Personal Information</h2>
      <p>It is an important to us that your Personal Information is up to date. We will take reasonable steps to make sure that your Personal Information is accurate, complete and up-to-date. If you find that the information we have is not up to date or is inaccurate, please advise us as soon as practicable so we can update our records and ensure we can continue to provide quality services to you.</p>
 
      <h2>Policy Updates</h2>

      <p>This Policy <span> may change </span> from time to time and is available on our website.</p>

      <h2>Privacy Policy Complaints and Enquiries</h2>

      <p>If you have any queries or complaints about our Privacy Policy please contact us at:</p>

      {/* We need to include the links down at the bottom here */}

      <p style={{ marginTop: "50px"}}><a href="https://www.google.com/maps/place/Silver+K+Gallery/@-37.8559802,145.023579,15z/data=!4m2!3m1!1s0x0:0x4d8a0c22ab0f2f3b?sa=X&ved=1t:2428&ictx=111">1092 High St, Armadale VIC 3143</a></p>
      <p><a href="tel:(03)95095577">(03) 95095577</a></p>
      <p><a href="mailto:colin@silverkgallery.com.au">colin@silverkgallery.com.au</a></p>
    </section>



  
  </>);
}